<template>
  <slice-block :slices="data.slices" />
</template>
<script setup>
import pageHelper from '~/utils/page-helper';
import getHead from '~/utils/get-head';
import { getEditoPageData } from '~/utils/helpers/data';
import getGuidesBreadcrumbs from '~/utils/helpers/get-guides-breadcrumbs';
import {
  routerLinks,
  guideLinks,
  articleLinks,
  marketLinks,
  productLinks,
  bannerLinks,
  smartButtonLinks,
  questionsAnswersLinks,
} from '~/utils/fetch-links';
import { isProRoute } from '~/utils/helpers/data';
import {
  LAYOUT_SET_BREADCRUMBS,
  TRACKING_SET_DATA,
} from '~/store/mutationTypes';
import setUrl from '~/utils/set-url';
import getJSONLD from '~/utils/structured-data';

const context = useNuxtApp();
const route = useRoute();
const requestEvent = useRequestEvent();
const params = route.params;
const { data } = await useAsyncData('data', async () => {
  try {
    const { $prismic, $store, $i18n, $enhancedLinkSerializer } = context;
    const document = await $prismic.client.getByUID('guide', params.uid, {
      fetchLinks: [
        ...routerLinks,
        ...guideLinks,
        ...articleLinks,
        ...marketLinks,
        ...productLinks,
        ...bannerLinks,
        ...smartButtonLinks,
        ...questionsAnswersLinks,
      ],
    });

    const { data: pageData } = document || {};

    if (
      document === undefined ||
      (params?.market !== 'assurance' &&
        !isProRoute(context, requestEvent) &&
        params?.market !== pageData?.market?.uid)
    ) {
      return context.error({ statusCode: 404 });
    }

    const url = setUrl(context, document, { route, requestEvent });

    const { data } = document;
    const market =
      data?.submarket?.data?.title ||
      data?.market?.data?.title_tracking ||
      data?.market?.data?.title ||
      data?.market?.uid ||
      null;

    $store.commit(`tracking/${TRACKING_SET_DATA}`, {
      market,
      page_type: document.type,
    });

    const breadcrumbs = getGuidesBreadcrumbs({
      market: document.data.market,
      breadcrumbTitle: document.data.breadcrumb_title,
      title: document.data.title,
      i18n: $i18n,
      serializer: $enhancedLinkSerializer,
      route,
      parent: document.data?.parent,
      context,
      requestEvent,
    });
    $store.commit(`layout/${LAYOUT_SET_BREADCRUMBS}`, breadcrumbs);

    const articleDocument = getEditoPageData(document);
    const slices = await pageHelper(articleDocument, context, undefined, {
      withBreadcrumb: true,
      relatedGuides: true,
    });

    return {
      url,
      slices,
      guideData: articleDocument.data,
      freespeeParameter: data?.market?.data?.freespee_parameter || null,
    };
  } catch (error) {
    context.error(error);
  }
});

const scripts = [
  getJSONLD('article', { ...data.value.guideData, url: data.value.url }),
];

useHead(getHead(context, scripts, data.value.freespeeParameter));
</script>
